import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS} from '@/queryClient'
import {httpExportAccessesRia, HttpExportAccessesRiaPayload} from '@/features/accesses/http/accesses.http'
import {ExportRiaError} from '@/features/accesses/types'
import {ExportJob} from '@/features/exports/types'
import {EXPORTS_LIST_KEY_PREFIX} from '@/features/exports/query/exportsKeys'

export const useExportRia = (
    options?: Omit<
        UseMutationOptions<ExportJob, AxiosError<ExportRiaError>, HttpExportAccessesRiaPayload>,
        'mutationKey' | 'mutationFn'
    >
) => {
    const queryClient = useQueryClient()

    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_EXPORT_RIA],
        mutationFn: (payload: HttpExportAccessesRiaPayload) => httpExportAccessesRia(payload),
        onSuccess: (...args) => {
            void queryClient.invalidateQueries({queryKey: EXPORTS_LIST_KEY_PREFIX})
            options?.onSuccess?.(...args)
        }
    })
}
